module.exports = __webpack_public_path__ + "static/media/ic_delete_invoices.e850ffb3.svg";